import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { IClient } from '../../../utils/types/IClient';
import { ISelectOption } from '../ISelectOption';

interface ClientSelectProps {
    id?: string | undefined;
    clients: IClient[];
    isClientsLoading: boolean;
    setSelectedCardCode: (cardCode: string) => void;
    selectedCardCode: string | null;
    isDisabled?: boolean | null;
}

const customStyles: StylesConfig<ISelectOption, false> = {
    control: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
        maxWidth: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menu: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
    }),
    option: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

const ClientSelect: React.FC<ClientSelectProps> = ({ id, clients, isClientsLoading, setSelectedCardCode, selectedCardCode, isDisabled }) => {
    const options: ISelectOption[] = clients.map((client) => ({
        value: client.cardCode ?? '',
        label: client.cardName ?? '-',
    }));

    const selectedOption = options.find((option) => option.value === selectedCardCode) || null;

    const handleChange = (selectedOption: ISelectOption | null) => {
        setSelectedCardCode(selectedOption ? selectedOption.value : '');
    };

    return <Select id={id} options={options} value={selectedOption} onChange={handleChange} placeholder={isClientsLoading ? 'Chargement ...' : '--- Client'} isLoading={isClientsLoading} isClearable isSearchable noOptionsMessage={() => 'Aucun client'} styles={customStyles} classNamePrefix="react-select" isDisabled={isDisabled ?? false} menuPortalTarget={document.body} />;
};

export default ClientSelect;
